import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { finalize, firstValueFrom, map, Observable, Subject, takeUntil } from 'rxjs';
import { GetVirtualAccountRequestParams, VirtualAccountData } from './virtualAccounts.interface';
import { Router } from '@angular/router';
import { VirtualAccountsService } from '../../services/virtualAccounts/virtualAccounts.service';
import { getOffset, getUtcDateRangeForLocalDate, getYesterday, showNotification } from 'src/app/shared/helpers/helpers';
import { ModalContent } from '../../shared/modal-content';
import { ModalComponent } from 'angular-custom-modal';
import { OptionItem } from '../../shared/types/api-responses.type';
import { MerchantsService } from '../../services/merchants/merchants.service';
import { ProvidersService } from '../../services/providers/providers.service';
import { CategoriesService } from '../../services/categories/categories.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { UserData } from '../../interfaces/users.interface';
import { selectCurrentUser } from '../../services/users/user.selectors';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-virtualAccounts',
  templateUrl: './virtualAccounts.component.html',
  styleUrls: ['./virtualAccounts.component.css'],
})
export class VirtualAccountsComponent implements OnInit, OnDestroy {
  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('excelDownloadBtn', { static: false }) excelDownloadBtn: any;

  private destroy$ = new Subject<void>();
  loading = false;
  merchants: OptionItem[] = [];
  providers: OptionItem[] = [];
  categories: OptionItem[] = [];

  DATE_ISO_FORMAT = 'yyyy-MM-dd';

  @ViewChild('createdFromPicker') createdFromPicker: any;
  createdFromConfig: FlatpickrOptions = {
    altInput: true,
    altFormat: 'd-m-Y',
    dateFormat: 'Y-m-d',
  };

  @ViewChild('createdToPicker') createdToPicker: any;
  createdToConfig: FlatpickrOptions = {
    altInput: true,
    altFormat: 'd-m-Y', // ✅ Ditampilkan sebagai DD-MM-YYYY
    dateFormat: 'Y-m-d', // ✅ Disimpan dalam format backend-friendly
    minDate: '', // will be set dynamically
    defaultDate: new Date(),
  };
  // createdFrom = new Date();

  banks: OptionItem[] = [
    { label: 'Bank Central Asia', value: 'BCA' },
    { label: 'Bank Mandiri', value: 'BMRI,MANDIRI' },
    { label: 'Bank Rakyat Indonesia', value: 'BRI' },
    { label: 'Bank CIMB Niaga', value: 'NIAGA' },
  ];

  status: OptionItem[] = [
    { label: 'Init', value: '3' },
    { label: 'Inquiry', value: '200' },
    { label: 'Paid with error Kilat', value: '301' },
    { label: 'Paid', value: '309' },
  ];

  types: OptionItem[] = [
    { label: 'Transaction', value: '1' },
    { label: 'Deposit', value: '2' },
  ];

  modalData: ModalContent = new ModalContent({
    header: 'Confirmation',
    body: 'Are you sure you want to delete this transaction?',
    showCloseButton: true,
    showConfirmButton: true,
    closeButtonLabel: 'Cancel',
    confirmButtonLabel: 'Delete',
    closeButtonClass: 'btn-secondary',
    confirmButtonClass: 'btn-danger',
  });

  selectedId = '';

  params = new GetVirtualAccountRequestParams();
  paramExcels = new GetVirtualAccountRequestParams();

  totalRows = 0;
  cols = [
    { field: 'no', title: 'No' },

    // --- Field dari Struct VirtualAccount ---
    // { field: 'id', title: 'ID' },
    { field: 'request_id', title: 'Order Id' },
    { field: 'status_name', title: 'Status' },
    // { field: 'res_data', title: 'Response Data' },
    { field: 'inquiry_at', title: 'Inquiry At' },
    { field: 'payment_at', title: 'Payment At' },

    // --- Field dari Struct VirtualAccountReq yang di-embed ---
    { field: 'tx_id', title: 'Tx ID' },
    { field: 'bill_id', title: 'Bill ID' },
    { field: 'va_no', title: 'VA No' },
    { field: 'request_id', title: 'Request ID' },
    { field: 'customer_name', title: 'Customer Name' },
    { field: 'bank', title: 'Bank' },
    { field: 'provider_code', title: 'Provider' },
    { field: 'total_amount', title: 'Total Amount' },
    //{ field: 'active_name', title: 'Active' },
    { field: 'active', title: 'Active' },
    { field: 'expired_at', title: 'Expired At' },
    // { field: 'additional_data', title: 'Additional Data' },
    // { field: 'req_data', title: 'Request Data' },

    // --- Field Metadata ---
    { field: 'created_at', title: 'Created At' },
    // { field: 'created_by', title: 'Created By' },
    // { field: 'updated_at', title: 'Updated At' },
    // { field: 'updated_by', title: 'Updated By' },
  ];

  pageSizeOptions = [5, 10, 25, 50, 100];
  rows: VirtualAccountData[] = [];
  rowsExcel: VirtualAccountData[] = [];

  userAuth$!: Observable<UserData | null>;
  isAdmin$!: Observable<boolean>;

  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private virtualAccountsService: VirtualAccountsService,
    private readonly merchantService: MerchantsService,
    private readonly providerService: ProvidersService, // private readonly roleService: RolesService,
    private readonly categoryService: CategoriesService,
    public storeData: Store<any>
  ) {}

  ngOnInit(): void {
    this.userAuth$ = this.storeData.select(selectCurrentUser);
    this.isAdmin$ = this.userAuth$.pipe(map((user) => user?.roles?.some((role) => role.code === 'admin') ?? false));

    this.getCategoryData().then();

    const yesterday = getYesterday();

    const { startUtc, endUtc } = getUtcDateRangeForLocalDate(yesterday);

    console.log(startUtc);
    console.log(endUtc);

    const NOW = DateTime.now().toFormat(this.DATE_ISO_FORMAT);
    this.params.created_from = NOW;
    this.params.created_to = NOW;
    this.createdFromConfig = {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      defaultDate: yesterday,
    };

    this.createdToConfig = {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      defaultDate: yesterday,
    };

    this.userAuth$.subscribe((user) => {
      if (user) {
        this.isAdmin$.pipe(takeUntil(this.destroy$)).subscribe((isAdmin) => {
          if (isAdmin) {
            this.getMerchantData().then();
            this.getProviderData().then();
          } else {
            this.params.merchantCode = user.merchant.code;
            this.getCategoryData().then();
          }
          this.getVirtualAccounts().then();
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getVirtualAccounts(): Promise<void> {
    this.loading = true;
    this.rows = [];
    this.rowsExcel = [];

    // get list for page
    try {
      this.virtualAccountsService
        .getVirtualAccountService(this.params)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.loading = false))
        )
        .subscribe({
          next: (response) => {
            this.rows = this.processDataForTable(response.data);
            this.totalRows = response.totalPage;
          },
          error: (err) => console.error('Error fetching virtualAccounts data:', err),
        });
    } catch (error) {
      showNotification('error', 'Failed to fetch virtualAccounts', JSON.stringify(error));
    } finally {
      this.loading = false;
    }

    this.onDownloadExcel();
  }

  onStatusChange(statusOption: OptionItem): void {
    this.params.status = null;
    if (statusOption) {
      console.log('Status Change:', statusOption.value);
      console.log('Status Change:', statusOption.label);
      this.params.status = statusOption.value;
    }
    this.getVirtualAccounts();
  }

  onBanksChange(bankOption: OptionItem): void {
    this.params.bank = null;
    if (bankOption) {
      console.log('Bank Change:', bankOption.value);
      console.log('Bank Change:', bankOption.label);
      this.params.bank = bankOption.value;
    }
    this.getVirtualAccounts();
  }

  private async getMerchantData(): Promise<void> {
    try {
      const { data } = await firstValueFrom(this.merchantService.getMerchants());
      this.merchants = data.map((merchant) => ({ label: merchant.name, value: merchant.code }));
    } catch (error) {
      showNotification('error', 'Failed to fetch merchants', JSON.stringify(error));
    }
  }

  private async getProviderData(): Promise<void> {
    try {
      const { data } = await firstValueFrom(this.providerService.getProviders());
      this.providers = data.map((provider) => ({ label: provider.name, value: provider.code }));
      console.log('providerOption: ', this.providers);
    } catch (error) {
      showNotification('error', 'Failed to fetch provider', JSON.stringify(error));
    }
  }

  private async getCategoryData(): Promise<void> {
    try {
      const { data } = await firstValueFrom(this.categoryService.getCategories());
      this.categories = data.map((category) => ({ label: category.name, value: category.code }));
      console.log('categoryOption: ', this.categories);
    } catch (error) {
      showNotification('error', 'Failed to fetch category', JSON.stringify(error));
    }
  }

  processDataForTable(data: VirtualAccountData[]) {
    return data.map((each, i) => {
      const date = new Date(each.updated_at);

      const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

      const formattedDate = `${localDate.getFullYear()}-${(localDate.getMonth() + 1).toString().padStart(2, '0')}-${localDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${localDate.getHours().toString().padStart(2, '0')}:${localDate.getMinutes().toString().padStart(2, '0')}:${localDate
        .getSeconds()
        .toString()
        .padStart(2, '0')}`;

      return {
        ...each,
        no: getOffset(this.params.pageNo, this.params.rowPerPage) + i + 1,
        updated_at: formattedDate,
      };
    });
  }

  changeServer(data: any): void {
    this.params.pageNo = data.current_page;
    this.params.rowPerPage = data.pagesize;
    this.params.filter = data.search;
    this.getVirtualAccounts();
  }

  onInputChanged(value: string): void {
    console.log('Debounced Input:', value);
    this.params.filter = '';
    if (value) {
      this.params.filter = value;
    }
    this.cdRef.detectChanges();
  }

  goToForm(id: string): void {
    if (id === 'new') {
      this.router.navigate(['/virtualAccounts/new']).then();
      return;
    }
    this.router.navigate(['/virtualAccounts/edit', id]).then();
    return;
  }

  async deleteTransaction(id: string): Promise<void> {
    this.loading = true;

    try {
      const delResp = await firstValueFrom(this.virtualAccountsService.deleteVirtualAccountById(id));
      showNotification('success', 'Success to delete transaction Detail', JSON.stringify(delResp));
      this.getVirtualAccounts();
    } catch (error) {
      console.error('Delete Transaction Error:', error);
    } finally {
      this.loading = false;
    }
  }

  async onModalDeleteConfirm(id: string): Promise<void> {
    await this.deleteTransaction(id);
    this.modal.close();
  }

  onMerchantChange(merchantOption: OptionItem): void {
    this.params.merchantCode = null;
    if (merchantOption) {
      console.log('Merchant Change:', merchantOption.value);
      console.log('Merchant Change:', merchantOption.label);
      this.params.merchantCode = merchantOption.value;
    }
    this.getVirtualAccounts();
  }

  onDownloadExcel(): void {
    this.loading = true;
    this.rowsExcel = [];
    this.paramExcels = { ...this.params, rowPerPage: 999999999999999999 };

    this.virtualAccountsService
      .getVirtualAccountService(this.paramExcels)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (response) => {
          this.rowsExcel = this.processDataForTable(response.data);
          //this.totalRows = response.totalPage;

          // ✅ trigger click setelah data siap
          setTimeout(() => {
            if (this.excelDownloadBtn?._elementRef?.nativeElement) {
              this.excelDownloadBtn._elementRef.nativeElement.click();
            }
          }, 200);
        },
        error: (err) => {
          console.error('Error fetching virtualAccounts data for excel:', err);
          showNotification('error', 'Gagal download excel', err.message);
        },
      });
  }

  onProviderChange(providerOption: OptionItem): void {
    this.params.provider_code = null;
    if (providerOption) {
      console.log('Provider Change:', providerOption.value);
      console.log('Provider Change:', providerOption.label);
      this.params.provider_code = providerOption.value;
    }
    this.getVirtualAccounts();
  }

  onCategoryChange(categoryOption: OptionItem): void {
    this.params.categoryCode = null;
    if (categoryOption) {
      console.log('Category Change:', categoryOption.value);
      console.log('Category Change:', categoryOption.label);
      this.params.categoryCode = categoryOption.value;
    }
    this.getVirtualAccounts();
  }

  onCreatedFromChange(event: any): void {
    this.params.created_from = null;

    const selectedCreatedFromDate = event?.target ? event.target.value : event;
    console.log('Selected Created From date:', selectedCreatedFromDate);

    if (!selectedCreatedFromDate) return;

    const selectedDate = new Date(selectedCreatedFromDate);
    const formattedDate = selectedDate.toISOString().split('T')[0];
    console.log('Formatted Created From Date:', formattedDate);

    // Calculate minDate (1 month before) and maxDate (1 month after)
    const minDate = new Date(selectedDate);
    minDate.setMonth(minDate.getMonth() - 1);

    const maxDate = new Date(selectedDate);
    maxDate.setMonth(maxDate.getMonth() + 1);

    // Set min and max for the createdToPicker
    this.createdToPicker.flatpickr.set('minDate', minDate);
    this.createdToPicker.flatpickr.set('maxDate', maxDate);
    this.createdToPicker.flatpickr.set('disable', [(date: Date) => date < minDate || date > maxDate]);

    console.log('Allowed createdTo range:', minDate, 'to', maxDate);
    this.params.created_from = selectedCreatedFromDate;

    // Call your logic
    this.getVirtualAccounts();
  }

  onCreatedToChange(event: any): void {
    this.params.created_to = null;
    const selectedCreatedToDate = event?.target ? event.target.value : event;

    console.log('Selected Created To date:', selectedCreatedToDate);

    if (!selectedCreatedToDate) return;

    this.params.created_to = selectedCreatedToDate;
    console.log('Selected this.params:', this.params);

    // Call your function to get virtualAccounts or any other logic you need
    this.getVirtualAccounts();
  }

  get isCompactFilter(): boolean {
    return this.providers.length === 0 && this.merchants.length === 0;
  }

  parseJson(jsonString: string): any {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      // Kembalikan objek error atau string asli jika formatnya tidak valid
      return { error: 'Invalid JSON', data: jsonString };
    }
  }
}
